import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Props from './TermsOfServiceComponent';
import { getXssFilter } from 'checkout/helpers/helpers';
import Translation from "../../../../shared/Translation";
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import Button from '@s/Button';

const iframeStyles = {
  position: 'fixed',
  top: 450,
  bottom: 154,
  left: 0,
  zIndex: 300,
  width: '100%',
  height: 'calc(100vh - 450px - 154px)',
}

class TermsOfService extends Component<Props> {
    interval = null;

    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            visibleIframe: null,
            kioskContainer: null,
        }
    }

    componentDidMount() {
      this.interval = setInterval(() => {
        const container = document.getElementById('kiosk__checkout');
        if (container) {
          this.setState({ kioskContainer: container });
          clearInterval(this.interval);
          return;
        }
      }, 100);
    }

    componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    onIframeLoad = (event) => {
      this.setState({ visibleIframe: event.target.name });
    }

    closeIframes = () => {
      this.setState({ visibleIframe: null });
    }

    tosChecked = () => {
        return () => {
            this.setState({
                checked: !this.state.checked
            })
        }
    }
    getLinkStart = (type) => {
      const target = this.props.isKiosk ? type : '_blank';
      return '<a href="' + this.props[`${type}Url`] + '" target="' + target + '" >'
    }

    getErrorComponent = () => {
      return (
        <p
          id="tos-error"
          className={clsx("input--error__text", { "input--error__text--hidden": !this.props.error })}
          role="alert"
          aria-live="polite"
          aria-atomic="true"
        >
          <Translation>
            {this.props.error}
          </Translation>
        </p>
      )
    }

    getTosTranslation = () => {
      return this.props.useLeapTos ? 'checkout__i_agree_to_tos_and_pp' : 'checkout__i_agree_to_tos';
    }

    getTosInterpolation = () => {
      const tosLinkStart = this.getLinkStart('tos');
      const linkEnd = '</a>';
      
      if (this.props.useLeapTos) {
        return {
          tosLinkStart,
          tosLinkEnd: linkEnd,
          ppLinkStart: this.getLinkStart('pp'),
          ppLinkEnd: linkEnd
        }
      }

      return {
        linkStart: tosLinkStart,
        linkEnd
      }
    }

    render() {
        const checkboxClass = classNames(
          'input__checkbox',
          {
            'tos__checkbox': !this.props.embedTos,
            'embed-tos__checkbox': this.props.embedTos,
            'input__checkbox--selected': this.state.checked
          }
        )

        return (
            <section className="checkout-form__section">
                <div className='form-card tos'>
                  <div className="form-card__content">
                    <div className={classNames('input', { ['input--error']: !!this.props.error })}>
                      {this.props.embedTos && !this.props.isKiosk ? (
                        <div>
                          <div className="input__top hidden">
                              <label className="input__label" htmlFor="tos"><Translation>{'checkout__terms_of_service'}</Translation></label>
                          </div>
                          <div id="tos-text" className="input__control tos__textarea" dangerouslySetInnerHTML={{ __html: getXssFilter().process(this.props.tos) }} />
                        </div>
                      ) : null}
                        <div className={checkboxClass}  >
                            <div className="input__checkbox-wrap" >
                                <div className="input__checkbox__input">
                                    <input
                                      type="checkbox"
                                      name="tos"
                                      id="tos"
                                      onChange={this.props.tosChanged}
                                      onClick={this.tosChecked()}
                                      aria-describedby="tos-error tos-text"
                                      aria-invalid={!!this.props.error}
                                      aria-required="true"
                                    />
                                </div>
                                <label htmlFor="tos" className="input__checkbox__label">
                                    <Translation interpolation={this.getTosInterpolation()}>
                                        {this.getTosTranslation()}
                                    </Translation>
                                </label>
                            </div>
                        </div>
                        {this.getErrorComponent()}
                    </div>
                  </div>
                </div>
                {this.props.isKiosk && this.state.kioskContainer && createPortal(
                  <Fragment>
                    {['tos', 'pp'].map((type) => (
                      <iframe
                        key={type}
                        name={type}
                        onLoad={this.onIframeLoad}
                        style={{
                          ...iframeStyles,
                          display: this.state.visibleIframe === type ? 'block' : 'none'
                        }}
                      />
                    ))}
                    {this.state.visibleIframe && (
                      <div className="tos-iframe-footer">
                        <Button onClick={this.closeIframes}>
                          <Translation>{'checkout__close'}</Translation>
                        </Button>
                      </div>
                    )}
                  </Fragment>,
                  this.state.kioskContainer
                )}
            </section>
        )
    }
}

TermsOfService.defaultProps = {
    tosChecked: false,
}

TermsOfService.propTypes = {
    tosChanged: PropTypes.func.isRequired,
    tos: PropTypes.string,
    tosLink: PropTypes.string,
    embedTos: PropTypes.bool,
}

export default TermsOfService
